import { render, staticRenderFns } from "./ConfigurarRecibosManage.vue?vue&type=template&id=39283d15&scoped=true"
import script from "./ConfigurarRecibosManage.vue?vue&type=script&lang=js"
export * from "./ConfigurarRecibosManage.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarRecibosManage.vue?vue&type=style&index=0&id=39283d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39283d15",
  null
  
)

export default component.exports